// extracted by mini-css-extract-plugin
module.exports = {"fading-balls":"FadingBalls_fading-balls__MZpHd","fade":"FadingBalls_fade__1y5R8"};